import { CustomPageSettings } from '@graphql/gql/graphql';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { NotificationLinkedContentPageType } from './utils';

const LOG = LoggerFactory.create('getNotificationCustomPageUrl');
let hasLoggedError = false;
/**
 * Function to get a document or external custom page url from customPageSettings for Notifications
 */
export const getNotificationCustomPageUrl = (
  type: string,
  id: string,
  customPageSettings: CustomPageSettings[],
  eventId: string
): string => {
  let url = '';
  const customPage = customPageSettings.find(e => e.pageId === id);
  if (customPage) {
    if (type === NotificationLinkedContentPageType.EXTERNAL_PAGES) {
      url = customPage.externalUrl;
    } else if (type === NotificationLinkedContentPageType.DOCUMENT_PAGES) {
      try {
        url = JSON.parse(customPage.documentAsset).assetUri;
      } catch (e) {
        if (!hasLoggedError) {
          LOG.error(`Error parsing documentAsset for custom page ${customPage.pageId}`, e);
          hasLoggedError = true;
        }
      }
    }
  } else {
    url = `/events/${eventId}/pages/error`;
  }
  return url;
};
